import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@environment';
import { configurePsdRenderWasmUrl } from '@lite-workspace/shared/psd-render-wasm/config';
import { initSentryErrorTracking, installVkPixel } from '@lite-workspace/shared/services/analytics';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

if (environment.vkPixelId) {
  installVkPixel(environment.vkPixelId);
}

initSentryErrorTracking({ dsn: environment.sentryDsn, environment: environment.sentryEnvironment, app: 'fotoclass' });

configurePsdRenderWasmUrl('/psd_render_bg.wasm');

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
